(function () {
  'use strict';

  var path = String(window.location.pathname || '').toLowerCase();
  var supportedPaths = {
    '/pages/fox-suspension-service': true,
    '/pages/rockshox-suspension-service': true,
    '/pages/marzocchi-suspension-service': true,
    '/pages/ohlins-suspension-service': true,
    '/pages/dvo-suspension-service': true,
    '/pages/cane-creek-suspension-service': true,
    '/pages/ext-suspension-service': true,
    '/pages/bos-suspension-service': true,
    '/pages/fast-suspension-service': true,
    '/pages/manitou-suspension-service': true
  };

  if (!supportedPaths[path]) return;

  var SHOPIFY_FILES = 'https://cdn.shopify.com/s/files/1/0002/4480/9769/files/';
  var LOGOS = {
    vorsprung: SHOPIFY_FILES + 'vorsprung-logo-black-transparent-600x240.png?width=720',
    fluidFocus: SHOPIFY_FILES + 'Fluid_Focus_Logo_600_x_600px_1.png?width=360',
    sar: SHOPIFY_FILES + 'SAR_Logo_600_x_600px.png?width=360',
    sprindex: SHOPIFY_FILES + '600_x_600_px_1.png?width=360'
  };

  var BRAND_NAMES = {
    '/pages/fox-suspension-service': 'Fox',
    '/pages/rockshox-suspension-service': 'RockShox',
    '/pages/marzocchi-suspension-service': 'Marzocchi',
    '/pages/ohlins-suspension-service': 'Öhlins',
    '/pages/dvo-suspension-service': 'DVO',
    '/pages/cane-creek-suspension-service': 'Cane Creek',
    '/pages/ext-suspension-service': 'EXT',
    '/pages/bos-suspension-service': 'BOS',
    '/pages/fast-suspension-service': 'FAST',
    '/pages/manitou-suspension-service': 'Manitou'
  };
  var BRAND_NAME = BRAND_NAMES[path] || 'Suspension';

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normaliseLower(value) {
    return normalise(value).toLowerCase();
  }

  function getSection() {
    return document.querySelector('[data-cjs-brand-performance-upgrades]');
  }

  function getGrid() {
    var section = getSection();
    return section ? section.querySelector('.cjs-brand-performance-upgrades__grid') : null;
  }

  function getPageBrandLogo() {
    var heroLogo = document.querySelector('.cjs-brand-page__hero-logo');
    if (!heroLogo) return '';
    return heroLogo.currentSrc || heroLogo.src || '';
  }

  function logoAlt(brand) {
    if (brand === 'vorsprung') return 'Vorsprung';
    if (brand === 'fluidFocus') return 'Fluid Focus';
    if (brand === 'sar') return 'Super Alloy Racing';
    if (brand === 'sprindex') return 'Sprindex';
    return BRAND_NAME;
  }

  function logoSource(brand) {
    if (brand === 'pageBrand') return getPageBrandLogo();
    return LOGOS[brand] || '';
  }

  function brandsForCard(card) {
    var heading = normaliseLower((card.querySelector('h3') || {}).textContent);
    var label = normaliseLower((card.querySelector('.cjs-brand-performance-upgrades__label') || {}).textContent);
    var combined = heading + ' ' + label;

    if (/smashpot|secus|luftkappe|fractive|tractive/.test(combined)) return ['vorsprung'];

    if (
      /fluid focus, bump stops & coil springs/.test(heading) ||
      /vivid, bump stop, preload & spring upgrades/.test(heading) ||
      /bomber cr piston, bump stop, preload & spring options/.test(heading)
    ) {
      return ['fluidFocus', 'sar', 'sprindex'];
    }

    if (/super alloy racing.*sprindex|sprindex.*super alloy racing/.test(combined)) {
      return ['sar', 'sprindex'];
    }

    if (/fluid focus|bump stop|charger piston|piston kit/.test(combined)) return ['fluidFocus'];

    return ['pageBrand'];
  }

  function cleanLabel(label) {
    return normalise(label)
      .replace(/^Vorsprung\s+/i, '')
      .replace(/^Fluid Focus\s+/i, '')
      .replace(/^RockShox\s+/i, '')
      .replace(/^Marzocchi\s+/i, '')
      .replace(/^Fox\s+/i, '')
      .replace(/^FAST\s+/i, '')
      .replace(/^BOS\s+/i, '')
      .replace(/^EXT\s+/i, '')
      .trim();
  }

  function addLogoRow(card) {
    if (!card) return;

    var brands = brandsForCard(card);
    var signature = brands.join('|');
    var existing = card.querySelector(':scope > .cjs-performance-logo-row');

    if (existing && existing.getAttribute('data-cjs-logo-signature') === signature) return;
    if (existing) existing.remove();

    var row = document.createElement('div');
    row.className = 'cjs-performance-logo-row';
    row.setAttribute('data-cjs-logo-signature', signature);

    brands.forEach(function (brand) {
      var src = logoSource(brand);
      if (!src) return;

      var holder = document.createElement('span');
      holder.className = 'cjs-performance-logo cjs-performance-logo--' + brand;

      var image = document.createElement('img');
      image.src = src;
      image.alt = logoAlt(brand) + ' logo';
      image.loading = 'lazy';
      image.decoding = 'async';

      holder.appendChild(image);
      row.appendChild(holder);
    });

    if (!row.children.length) return;

    var label = card.querySelector(':scope > .cjs-brand-performance-upgrades__label');
    if (label) {
      label.textContent = cleanLabel(label.textContent);
      card.insertBefore(row, label);
    } else {
      card.insertBefore(row, card.firstChild);
    }
  }

  function markServiceGrid() {
    var serviceGrid = document.querySelector('.cjs-brand-page__service-grid');
    if (!serviceGrid) return;

    var cards = serviceGrid.querySelectorAll(':scope > .cjs-brand-page__service-card');
    serviceGrid.setAttribute('data-cjs-service-count', String(cards.length));
  }

  function addStyles() {
    if (document.getElementById('cjs-brand-performance-clean-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-brand-performance-clean-styles';
    style.textContent =
      '[data-cjs-brand-performance-upgrades]{margin-top:54px!important;padding-top:0!important;}' +
      '[data-cjs-brand-performance-upgrades] .cjs-brand-page__section-header{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(300px,.72fr)!important;gap:44px!important;align-items:end!important;margin-bottom:30px!important;padding-bottom:22px!important;border-bottom:1px solid var(--cjs-border,#e6e2dd)!important;}' +
      '[data-cjs-brand-performance-upgrades] .cjs-brand-page__section-header h2{font-size:clamp(30px,3.4vw,46px)!important;line-height:1.02!important;letter-spacing:-.035em!important;}' +
      '[data-cjs-brand-performance-upgrades] .cjs-brand-page__section-copy{max-width:570px!important;color:var(--cjs-muted,#606060)!important;font-size:13px!important;line-height:1.62!important;}' +
      '.cjs-brand-performance-upgrades__grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:20px!important;align-items:stretch!important;}' +
      '.cjs-brand-performance-upgrades__card{display:flex!important;flex-direction:column!important;min-width:0!important;padding:32px 32px 27px!important;border:1px solid var(--cjs-border,#e6e2dd)!important;border-radius:12px!important;background:#fff!important;box-shadow:none!important;transition:border-color .18s ease,transform .18s ease,box-shadow .18s ease!important;}' +
      '.cjs-brand-performance-upgrades__card:hover{transform:translateY(-1px)!important;border-color:#d6d0ca!important;box-shadow:0 9px 24px rgba(17,17,17,.045)!important;}' +
      '.cjs-performance-logo-row{display:flex;align-items:center;flex-wrap:wrap;gap:24px;min-height:122px;margin:0 0 18px;padding:0;}' +
      '.cjs-performance-logo{display:inline-flex;align-items:center;justify-content:flex-start;height:108px;max-width:350px;}' +
      '.cjs-performance-logo img{display:block;width:auto;height:auto;max-width:100%;max-height:100px;object-fit:contain;object-position:left center;}' +
      '.cjs-performance-logo--pageBrand,.cjs-performance-logo--vorsprung{max-width:350px;}' +
      '.cjs-performance-logo--fluidFocus{height:110px;max-width:142px;}' +
      '.cjs-performance-logo--fluidFocus img{max-height:104px;}' +
      '.cjs-performance-logo--sar,.cjs-performance-logo--sprindex{height:100px;max-width:118px;}' +
      '.cjs-performance-logo--sar img,.cjs-performance-logo--sprindex img{max-height:96px;}' +
      '.cjs-brand-performance-upgrades__label{margin:0 0 8px!important;color:var(--cjs-accent,#a8323a)!important;font-size:10px!important;font-weight:850!important;line-height:1.3!important;letter-spacing:.14em!important;text-transform:uppercase!important;}' +
      '.cjs-brand-performance-upgrades__card h3{margin:0 0 11px!important;color:var(--cjs-text,#111)!important;font-size:21px!important;font-weight:850!important;line-height:1.12!important;letter-spacing:-.022em!important;}' +
      '.cjs-brand-performance-upgrades__text{margin:0 0 17px!important;color:var(--cjs-muted,#606060)!important;font-size:13px!important;line-height:1.62!important;}' +
      '.cjs-brand-performance-upgrades__models{margin:0!important;padding:15px 0 0!important;border-top:1px solid var(--cjs-border,#e6e2dd)!important;color:#65615d!important;font-size:11.5px!important;line-height:1.56!important;}' +
      '.cjs-brand-performance-upgrades__models strong{display:block;margin-bottom:3px;color:var(--cjs-text,#111)!important;font-weight:800!important;}' +
      '.cjs-performance-fitment-row{display:block;margin-top:7px;}' +
      '.cjs-performance-fitment-row b{display:inline-block;min-width:76px;margin-right:4px;color:var(--cjs-text,#111);font-weight:800;}' +
      '.cjs-brand-performance-upgrades__actions{display:grid!important;grid-template-columns:1fr!important;gap:0!important;margin-top:auto!important;padding-top:19px!important;}' +
      '.cjs-brand-performance-upgrades__actions .cjs-brand-page__card-link{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:16px!important;min-height:40px!important;margin:0!important;padding:10px 0!important;border-top:1px solid var(--cjs-border,#e6e2dd)!important;color:var(--cjs-accent,#a8323a)!important;font-size:12px!important;font-weight:800!important;line-height:1.25!important;text-decoration:none!important;}' +
      '.cjs-brand-performance-upgrades__actions .cjs-brand-page__card-link:first-child{border-top:0!important;}' +
      '.cjs-brand-performance-upgrades__actions .cjs-brand-page__card-link:hover{color:#84262d!important;}' +
      '@media(min-width:1100px){.cjs-brand-page__service-grid[data-cjs-service-count="7"]{grid-template-columns:repeat(12,minmax(0,1fr))!important;}.cjs-brand-page__service-grid[data-cjs-service-count="7"]>.cjs-brand-page__service-card{grid-column:span 3!important;}.cjs-brand-page__service-grid[data-cjs-service-count="7"]>.cjs-brand-page__service-card:nth-child(n+5){grid-column:span 4!important;}}' +
      '@media(max-width:899px){[data-cjs-brand-performance-upgrades] .cjs-brand-page__section-header{grid-template-columns:1fr!important;gap:13px!important;}.cjs-brand-performance-upgrades__grid{grid-template-columns:1fr!important;}}' +
      '@media(max-width:749px){[data-cjs-brand-performance-upgrades]{margin-top:42px!important;}.cjs-brand-performance-upgrades__card{padding:25px 21px 22px!important;}.cjs-performance-logo-row{min-height:108px;margin-bottom:15px;gap:16px;}.cjs-performance-logo{height:96px;max-width:280px;}.cjs-performance-logo img{max-height:90px;}.cjs-performance-logo--fluidFocus{height:100px;max-width:120px;}.cjs-performance-logo--fluidFocus img{max-height:94px;}.cjs-performance-logo--sar,.cjs-performance-logo--sprindex{height:90px;max-width:100px;}.cjs-performance-logo--sar img,.cjs-performance-logo--sprindex img{max-height:86px;}.cjs-brand-performance-upgrades__card h3{font-size:20px!important;}}';

    document.head.appendChild(style);
  }

  function polishHeader() {
    var section = getSection();
    if (!section) return;

    var heading = section.querySelector('.cjs-brand-page__section-header h2');
    if (heading) heading.textContent = BRAND_NAME + ' Performance Upgrades';

    var copy = section.querySelector('.cjs-brand-page__section-copy');
    if (copy) {
      var paragraph = copy.querySelector('p') || copy;
      paragraph.textContent = 'Confirmed upgrade options only. Select your exact model for generation-specific compatibility, service requirements and fitment notes.';
    }
  }

  function run() {
    markServiceGrid();
    addStyles();

    var grid = getGrid();
    if (!grid) return;

    polishHeader();
    Array.prototype.slice.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card')).forEach(addLogoRow);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  window.setTimeout(run, 150);
  window.setTimeout(run, 650);
  window.setTimeout(run, 1500);
  document.addEventListener('shopify:section:load', function () { window.requestAnimationFrame(run); });
})();